/**
 * sha256 de un blob, en el móvil.
 *
 * Es la mitad del contrato que hace que la empleada pueda borrar su copia
 * local con tranquilidad: el móvil calcula el hash, lo anuncia al abrir la
 * subida, y el servidor recalcula el suyo sobre el fichero ensamblado. Si no
 * coinciden, no hay `asset` y el clip se reintenta.
 *
 * `crypto.subtle` solo existe en origen seguro (HTTPS o localhost). Es una de
 * las razones por las que el HTTPS no se negocia, junto con la cámara.
 */

export async function sha256(blob: Blob): Promise<string> {
    if (!globalThis.crypto?.subtle) {
        throw new Error(
            'crypto.subtle no está disponible. Hace falta HTTPS: sin origen seguro no hay ni hash ni cámara.'
        );
    }

    // Un clip de 30 MB entero en memoria para hashearlo: en un móvil de gama
    // baja eso ya es notable, pero la alternativa —trocear -- no existe en la
    // API estándar (no hay digest incremental en WebCrypto). Por eso el tope
    // de tamaño por clip está en 120 MB y los clips son cortos.
    const buffer = await blob.arrayBuffer();
    const digest = await crypto.subtle.digest('SHA-256', buffer);

    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

/** El hash de un trozo, para comprobar que el que se manda es el que se leyó. */
export async function sha256DeTrozo(blob: Blob, desde: number, hasta: number): Promise<string> {
    return sha256(blob.slice(desde, hasta));
}
